<template>
    <div v-if="!showGroupIcons" class="sidebar-results">
        <template v-if="results?.icons.length >= 1 || results?.groups.length >= 1 ">
            <div v-if="results.icons.length >= 1" class="d-flex w-100 flex-column overflow-y-scroll border-bottom icon-list" :id="`graphic-tools_${_uid}_0`">
                <span class="font-semibold sticky-top fs-5 bg-white">Icons</span>
                <!-- show icons -->
                <IconSearchResult
                    v-for="result in results.icons"
                    :key="result.public_id"
                    :marker="result"
                />
            </div>
            <div v-if="results.risks.length >= 1" class="d-flex w-100 flex-column overflow-y-scroll border-bottom mt-2 mb-10 risk-assesments">
                <span class="font-semibold sticky-top fs-5">Risk Assessments</span>
                <div v-for="(risk, index) in results.risks"
                    :group="index"
                    :key="risk.ulid"
                    :marker="risk"
                    class="p-3 d-flex col justify-content-between align-items-center"
                >
                    {{ buildName(risk) }}
                    <button class="btn btn-sm btn-outline-primary" @click="useRA(risk)">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="16" height="16"><path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"></path></svg>
                    </button>
                </div>
            </div>
        </template>
    </div>
    <div v-else-if="showGroupIcons" class="h-100">
        <div v-if="groupIcons.length >= 1"
            class="d-flex w-100 flex-column overflow-scroll border-bottom"
            :id="`graphic-tools_${_uid}_0`">
            <span class="font-semibold sticky-top bg-white fs-5">Icons</span>
            <!-- show icons -->
            <div class="d-flex p-2 w-full">
                <button class="btn btn-sm btn-outline-info mx-auto" @click="linkCollectionToProject">Link Collection</button>
            </div>
            <IconSearchResult v-for="result in groupIcons" :key="result.public_id" :marker="result" />
        </div>
    </div>

</template>

<script>
import IconSearchResult from './IconSearchResult.vue';

export default {
    components: { IconSearchResult },
    inject: ['notyf'],
    props: {
        results: {
                activeRisks: [],
                icons: [],
                groups: [],
            },
    },
    data() {
        return {
            groupIcons: [],
            showGroupIcons: false,
            collection: null,
        }
    },
    methods: {
        clickedHandler(selected) {
            this.groupIcons = this.results?.groups[selected]?.markers
            this.collection = this.results?.groups[selected]
            this.showGroupIcons = true
        },
        attachActions() {
            if (this.results?.icons.length >= 1 || this.results?.groups.length >= 1) {
                window.globalButtonAttach(document.getElementById(`graphic-tools_${this._uid}_0`))
                window.globalButtonAttach(document.getElementById(`graphic-tools_${this._uid}_1`))
            }
        },

        buildName(risk) {
            if(risk.is_template) {
                return `${risk.company.name} / ${risk.owner.name} / ${risk.title} (Template)`;
            }
            return `${risk.markup.name} / ${risk.owner.name} / ${risk.title}`
        },


        linkCollectionToProject() {

            axios.post(`/markup/${window.savedMarkup.uuid}/collection`, {
                collection: this.collection.id
            }).then(response => {
                if (response.status >= 200 && response.status < 300) {
                    this.notyf.success('Icon Collection Linked');

                    document.dispatchEvent(new CustomEvent('cm:marker_collection_linked'));
                }
            })
            .catch(error => {
                if (error.status == 403) {
                    this.notyf.error('You do not have access to this action');
                    return
                }

                if (error.status == 402) {
                    this.notyf.error('Payment Required')
                    return
                }

                this.notyf.error('General Error linking collection, please try again')
            })
        },
        useRA(risk) {
            axios.post(`/markup/${savedMarkup.uuid}/risk/${risk.ulid}`)
                .then(response => {
                    document.dispatchEvent(new CustomEvent('cm:toggle-risk-sidebar-after-selection', {
                        detail:  {
                            project: response.data.project,
                            risk: response.data.risk
                        }
                    }))
                })
                .catch(error => {
                    this.notyf.error('Unable to link Risk Assessment')
                })
        },
    },
    updated () {
        // this.attachActions();
    },
    watch: {
        results: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
                this.showGroupIcons = false
            }
        }
    },
}
</script>

<style scoped>
.icon-list {
    margin-bottom: 1rem !important;
}

.sidebar-results {
    overflow-y: scroll;
    overflow-x: visible;
    height: 92vh;
    margin-bottom: 46px;
    padding-bottom: 50px;
}
</style>
